import apiClient from './apiClient';

export const submitContactForm = (formData) => {
    return apiClient.post('/tenant/request-demo/requestDemo', formData);
};

// Add other contact-related API calls here
